// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-card-grid{display:grid;grid-gap:var(--grid-gap-mobile)}@media screen and (min-width:769px){.gw-card-grid{grid-template-columns:repeat(2,1fr);grid-gap:var(--grid-gap-tablet)}}@media screen and (min-width:993px){.gw-card-grid{grid-template-columns:repeat(3,1fr);grid-gap:var(--grid-gap-desktop)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
